<template>
  <div class="page-section">
    <div class="section-container">
      <section v-reveal>
        <span class="section-label">Help</span>
        <h1 class="section-title">帮助中心</h1>
        <p class="section-subtitle">
          文档、常见问题与视频教程持续更新中。遇到问题可通过站内工单或邮件获得支持。
        </p>
        <ul class="points">
          <li>新用户入门：环境准备、组织与权限、主数据导入与首单演练。</li>
          <li>常见问题：接口对接、库存差异、报关与物流状态同步等专题整理中。</li>
          <li>支持渠道：工作日在线客服、邮件工单与专属客户成功经理（企业版）。</li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.points {
  margin: 0;
  padding: 24px 28px;
  list-style: none;
  color: var(--text-muted);
  line-height: 1.85;
  background: var(--bg-soft);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

.points li {
  margin-bottom: 12px;
  padding-left: 20px;
  position: relative;
}

.points li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 10px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--primary);
}

.points li:last-child {
  margin-bottom: 0;
}
</style>
